import LayoutMain from './../../../layouts/LayoutMain.vue';
import ProgressHUD from './../../ProgressHUD/index.vue'
import Footer from './../../Footers/Footer/index.vue'
import { Api, Toast } from './../../../services'
import ModalDialogAddPayment from './ModalDialogs/addPayment.vue'

export default {
  name: 'EditProfile',
  props: [],
  components: {
    LayoutMain,
    ProgressHUD,
    Footer,
    ModalDialogAddPayment
  },
  data() {
    return {
      userData: null,
      validationMessage: '',
      newAvatarImmage: null,
      paymentMethods: {},
      methodNames: {"btc": "Bitcoin Wallet Address", "eth": "Green Wallet Address", "cc": "Credit Card", "bacc": "Bank Account", "pp": "Paypal"}, 
    }
  },
  computed: {

  },
  methods: {
    async displayFreshPaymentData() {
      try {
        var response = await Api.getPaymentMethods()
        this.paymentMethods = response.data.results

      } catch (error) {
        console.error(error)
        this.validationMessage = error.message

        Toast.error({
          toast: this.$toast,
          title: 'Error',
          message: error.message,
        })
      } finally {
        // this.$refs.progress.hide()
      }
    },
    openPayment() {
      this.$refs.payment.openDialog()
    },
    async save() {
      try {
        const isValid = await this.$validator.validateAll()
        if (!isValid) {
          Toast.validationFieldsError({ toast: this.$toast })
          return
        }

        this.$refs.progress.show()

        console.log("PM **********************")
        console.log(this.paymentMethods)

        await Api.updatePaymentMethods({
          data: JSON.stringify(this.paymentMethods)
        })

        Toast.success({
          toast: this.$toast,
          title: 'Success!',
          message: 'Payment Methods Successfully Saved',
        })

      } catch (error) {
        console.error(error)
        this.validationMessage = error.message

        Toast.error({
          toast: this.$toast,
          title: 'Error',
          message: error.message,
        })
      } finally {
        this.$refs.progress.hide()
      }
    },
    async remove(method, idx) {
      try {
        await Api.removePaymentMethod({
          method: method,
          idx: idx,
        })

        await this.displayFreshPaymentData()

        Toast.success({
          toast: this.$toast,
          title: 'Success!',
          message: 'Successfully REMOVED',
        })
      } catch (error) {
        console.error(error)
        this.validationMessage = error.message

        Toast.error({
          toast: this.$toast,
          title: 'Error',
          message: error.message,
        })
      }
    },
  },
  created() {
    $(function () {
      $('[data-toggle="tooltip"]').tooltip()
    })

    this.displayFreshPaymentData()
  },
}



// WEBPACK FOOTER //
// ./src/components/Account/EditPayment/EditPayment.component.js